module.exports = __webpack_public_path__ + "fonts/Aller_BdIt.ce40230b.ttf";